import "@capacitor/core";
import * as L from "react";
import { useRef as et, useEffect as ee, useState as tt, useCallback as Mt } from "react";
const Ma = (t) => {
  if (t.length < 12)
    throw new Error("Password must contain at least 12 characters");
  if (!/[A-Z]/.test(t))
    throw new Error(
      "Password must contain at least 1 uppercase character  (A..Z)"
    );
  if (!/\d/.test(t))
    throw new Error(
      "Password must contain at least 1 number character  (0..9)"
    );
  if (!/[!@#$%^&*()_+\-={}|[\];:,./<>?~`]/.test(t))
    throw new Error(
      "Password must contain at least 1 special character  (!@#$%^&*()_+-={}|[];:,./<>?~`)"
    );
  const n = t.match(
    /[^A-Za-z\d!@#$%^&*()_+\-={}|[\];:,./<>?~`]/g
  );
  if (n != null && n.length)
    throw new Error(
      `Password contains invalid characters ${n.map((r) => `(${r})`).join(", ")}`
    );
  return !0;
}, Ee = "body-wrapper", Da = (t = Ee) => {
  var n;
  return ((n = document.getElementById(t)) == null ? void 0 : n.scrollTop) || 0;
}, Ca = (t) => {
  const n = document.getElementById(Ee);
  n && (n.scrollTop = t);
}, Pa = (t, n = Ee, { includeElementHeight: r = !0, scrollOffset: a = 0 } = {}) => {
  const e = document.getElementById(n);
  if (e && e.scrollTo && t) {
    const o = t.offsetTop, i = r ? t.offsetHeight : 0, s = o + i + a;
    e.scrollTo({
      top: s,
      behavior: "smooth"
    });
  }
};
function Oa(t) {
  t.preventDefault(), t.stopPropagation(), t.nativeEvent.stopImmediatePropagation();
}
const ka = async (t, n) => {
  if (!navigator.clipboard) {
    n(new Error("Clipboard API not supported"));
    return;
  }
  try {
    await navigator.clipboard.writeText(window.location.href), t();
  } catch (r) {
    n(r);
  }
}, Ea = (t = "localStorage") => {
  const n = t === "sessionStorage" ? sessionStorage : localStorage;
  return {
    setItem: (o, i) => {
      n.setItem(o, JSON.stringify(i));
    },
    getItem: (o) => {
      try {
        const i = n.getItem(o);
        if (i)
          return JSON.parse(i);
      } catch {
      }
    },
    removeItem: (o) => {
      n.removeItem(o);
    },
    clear: n.clear
  };
}, Dt = (t, n) => n.sizeIdx < 2 ? 0 : n.sizeIdx === 2 ? t < 10 ? 1 : 0 : 1, Ua = (t, {
  precision: n = Dt,
  sizeTerms: r = ["bytes", "kb", "mb", "gb", "tb", "pb"],
  threshold: a = 1e3
} = {}) => {
  if (t === 0)
    return "";
  const e = Math.min(
    Math.floor(Math.log(t) / Math.log(a)),
    r.length - 1
  ), o = t / Math.pow(a, e), i = r[e], s = typeof n == "number" ? n : Array.isArray(n) ? n[e] || 0 : n(o, { threshold: a, bytes: t, sizeIdx: e, unit: i });
  return `${parseFloat(o.toFixed(s))} ${i}`;
}, Ct = "Something went wrong during submission.", Ya = (t, n = Ct) => {
  var r, a, e, o, i, s, u, c;
  if (t)
    return Array.isArray((a = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data) == null ? void 0 : a.errors) ? (s = (i = (o = (e = t == null ? void 0 : t.response) == null ? void 0 : e.data) == null ? void 0 : o.errors) == null ? void 0 : i[0]) == null ? void 0 : s.message : typeof (t == null ? void 0 : t.message) == "string" ? t.message : typeof (t == null ? void 0 : t.error) == "string" ? t.error : typeof ((c = (u = t == null ? void 0 : t.errors) == null ? void 0 : u[0]) == null ? void 0 : c.message) == "string" ? t.errors[0].message : n;
};
function Pt(t) {
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}
function _a(t) {
  return t ? Pt(t).slice(0, t.length - 1) : "";
}
const Na = (t = "") => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;"), Wa = (t) => t.replace(/(\r\n|\r|\n)/g, "<br/>"), Ia = (t) => t.split(/[\s+]/).map(
  (r) => `${(r[0] || "").toUpperCase()}${r.slice(1).toLowerCase()}`
).join("");
function Aa(t) {
  return typeof t != "number" ? "" : `${(t / 1024).toFixed(2)} KB`;
}
const Ha = (t) => {
  const n = t.split("."), r = n.length > 1 ? n.pop() : void 0, a = n.join(".");
  return {
    fileName: t,
    baseName: a,
    extension: r
  };
}, La = (t) => {
  const n = t.includes("\\n"), r = t.includes(`
`), a = t.includes("</div>") && t.includes("<div>") && !t.includes("\\n") && !t.includes(`
`);
  return !n && !r || a ? t : t.replace(/<[^>]*>/g, "").replace(/\\n/g, `
`).split(/\r\n|\r|\n/).map((i) => i.trim() ? `<div>${i}</div>` : "<div></div>").join("");
}, $a = (t, n) => n > 0 ? Math.floor(t * 100 / n) : 0, Ra = (t) => `${Math.floor(t ?? 0)}%`, Ot = (t, n = "") => {
  const r = Number(t);
  return !Number.isFinite(r) || t === "" || t === null || t === void 0 ? n : r.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
}, qa = (t, n) => {
  const a = parseInt(t) / 100;
  return Ot(a, n);
};
function j(t) {
  "@babel/helpers - typeof";
  return j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, j(t);
}
function A(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var n = Number(t);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function M(t, n) {
  if (n.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function b(t) {
  M(1, arguments);
  var n = Object.prototype.toString.call(t);
  return t instanceof Date || j(t) === "object" && n === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || n === "[object Number]" ? new Date(t) : ((typeof t == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function kt(t, n) {
  M(2, arguments);
  var r = b(t).getTime(), a = A(n);
  return new Date(r + a);
}
var Et = {};
function re() {
  return Et;
}
function pe(t) {
  var n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return n.setUTCFullYear(t.getFullYear()), t.getTime() - n.getTime();
}
function he(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = r.getTime() - a.getTime();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
var Ut = 6e4, Yt = 36e5, _t = 1e3;
function Nt(t) {
  return M(1, arguments), t instanceof Date || j(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Wt(t) {
  if (M(1, arguments), !Nt(t) && typeof t != "number")
    return !1;
  var n = b(t);
  return !isNaN(Number(n));
}
function It(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = r.getFullYear() - a.getFullYear(), o = r.getMonth() - a.getMonth();
  return e * 12 + o;
}
function At(t, n) {
  return M(2, arguments), b(t).getTime() - b(n).getTime();
}
var Fe = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, Ht = "trunc";
function Lt(t) {
  return t ? Fe[t] : Fe[Ht];
}
function $t(t) {
  M(1, arguments);
  var n = b(t);
  return n.setHours(23, 59, 59, 999), n;
}
function Rt(t) {
  M(1, arguments);
  var n = b(t), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function qt(t) {
  M(1, arguments);
  var n = b(t);
  return $t(n).getTime() === Rt(n).getTime();
}
function St(t, n) {
  M(2, arguments);
  var r = b(t), a = b(n), e = he(r, a), o = Math.abs(It(r, a)), i;
  if (o < 1)
    i = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - e * o);
    var s = he(r, a) === -e;
    qt(b(t)) && o === 1 && he(t, a) === 1 && (s = !1), i = e * (o - Number(s));
  }
  return i === 0 ? 0 : i;
}
function Ft(t, n, r) {
  M(2, arguments);
  var a = At(t, n) / 1e3;
  return Lt(void 0)(a);
}
function rt(t, n) {
  M(2, arguments);
  var r = A(n);
  return kt(t, -r);
}
var Qt = 864e5;
function jt(t) {
  M(1, arguments);
  var n = b(t), r = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var a = n.getTime(), e = r - a;
  return Math.floor(e / Qt) + 1;
}
function ie(t) {
  M(1, arguments);
  var n = 1, r = b(t), a = r.getUTCDay(), e = (a < n ? 7 : 0) + a - n;
  return r.setUTCDate(r.getUTCDate() - e), r.setUTCHours(0, 0, 0, 0), r;
}
function nt(t) {
  M(1, arguments);
  var n = b(t), r = n.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var e = ie(a), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = ie(o);
  return n.getTime() >= e.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function Bt(t) {
  M(1, arguments);
  var n = nt(t), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = ie(r);
  return a;
}
var Xt = 6048e5;
function at(t) {
  M(1, arguments);
  var n = b(t), r = ie(n).getTime() - Bt(n).getTime();
  return Math.round(r / Xt) + 1;
}
function te(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = re(), d = A((r = (a = (e = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : v.weekStartsOn) !== null && a !== void 0 ? a : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = b(t), m = h.getUTCDay(), D = (m < d ? 7 : 0) + m - d;
  return h.setUTCDate(h.getUTCDate() - D), h.setUTCHours(0, 0, 0, 0), h;
}
function Ue(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = b(t), d = v.getUTCFullYear(), h = re(), m = A((r = (a = (e = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : h.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = h.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var D = /* @__PURE__ */ new Date(0);
  D.setUTCFullYear(d + 1, 0, m), D.setUTCHours(0, 0, 0, 0);
  var W = te(D, n), N = /* @__PURE__ */ new Date(0);
  N.setUTCFullYear(d, 0, m), N.setUTCHours(0, 0, 0, 0);
  var R = te(N, n);
  return v.getTime() >= W.getTime() ? d + 1 : v.getTime() >= R.getTime() ? d : d - 1;
}
function zt(t, n) {
  var r, a, e, o, i, s, u, c;
  M(1, arguments);
  var v = re(), d = A((r = (a = (e = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : v.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), h = Ue(t, n), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(h, 0, d), m.setUTCHours(0, 0, 0, 0);
  var D = te(m, n);
  return D;
}
var Gt = 6048e5;
function it(t, n) {
  M(1, arguments);
  var r = b(t), a = te(r, n).getTime() - zt(r, n).getTime();
  return Math.round(a / Gt) + 1;
}
function x(t, n) {
  for (var r = t < 0 ? "-" : "", a = Math.abs(t).toString(); a.length < n; )
    a = "0" + a;
  return r + a;
}
var G = {
  // Year
  y: function(n, r) {
    var a = n.getUTCFullYear(), e = a > 0 ? a : 1 - a;
    return x(r === "yy" ? e % 100 : e, r.length);
  },
  // Month
  M: function(n, r) {
    var a = n.getUTCMonth();
    return r === "M" ? String(a + 1) : x(a + 1, 2);
  },
  // Day of the month
  d: function(n, r) {
    return x(n.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(n, r) {
    var a = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, r) {
    return x(n.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(n, r) {
    return x(n.getUTCHours(), r.length);
  },
  // Minute
  m: function(n, r) {
    return x(n.getUTCMinutes(), r.length);
  },
  // Second
  s: function(n, r) {
    return x(n.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(n, r) {
    var a = r.length, e = n.getUTCMilliseconds(), o = Math.floor(e * Math.pow(10, a - 3));
    return x(o, r.length);
  }
}, ne = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Vt = {
  // Era
  G: function(n, r, a) {
    var e = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(e, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(e, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(e, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, r, a) {
    if (r === "yo") {
      var e = n.getUTCFullYear(), o = e > 0 ? e : 1 - e;
      return a.ordinalNumber(o, {
        unit: "year"
      });
    }
    return G.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, a, e) {
    var o = Ue(n, e), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      var s = i % 100;
      return x(s, 2);
    }
    return r === "Yo" ? a.ordinalNumber(i, {
      unit: "year"
    }) : x(i, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    var a = nt(n);
    return x(a, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    var a = n.getUTCFullYear();
    return x(a, r.length);
  },
  // Quarter
  Q: function(n, r, a) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(e);
      case "QQ":
        return x(e, 2);
      case "Qo":
        return a.ordinalNumber(e, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, a) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(e);
      case "qq":
        return x(e, 2);
      case "qo":
        return a.ordinalNumber(e, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, a) {
    var e = n.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return G.M(n, r);
      case "Mo":
        return a.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, r, a) {
    var e = n.getUTCMonth();
    switch (r) {
      case "L":
        return String(e + 1);
      case "LL":
        return x(e + 1, 2);
      case "Lo":
        return a.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, r, a, e) {
    var o = it(n, e);
    return r === "wo" ? a.ordinalNumber(o, {
      unit: "week"
    }) : x(o, r.length);
  },
  // ISO week of year
  I: function(n, r, a) {
    var e = at(n);
    return r === "Io" ? a.ordinalNumber(e, {
      unit: "week"
    }) : x(e, r.length);
  },
  // Day of the month
  d: function(n, r, a) {
    return r === "do" ? a.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : G.d(n, r);
  },
  // Day of year
  D: function(n, r, a) {
    var e = jt(n);
    return r === "Do" ? a.ordinalNumber(e, {
      unit: "dayOfYear"
    }) : x(e, r.length);
  },
  // Day of week
  E: function(n, r, a) {
    var e = n.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, a, e) {
    var o = n.getUTCDay(), i = (o - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return x(i, 2);
      case "eo":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return a.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, a, e) {
    var o = n.getUTCDay(), i = (o - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return x(i, r.length);
      case "co":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return a.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, a) {
    var e = n.getUTCDay(), o = e === 0 ? 7 : e;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return x(o, r.length);
      case "io":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(e, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, a) {
    var e = n.getUTCHours(), o = e / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, a) {
    var e = n.getUTCHours(), o;
    switch (e === 12 ? o = ne.noon : e === 0 ? o = ne.midnight : o = e / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, a) {
    var e = n.getUTCHours(), o;
    switch (e >= 17 ? o = ne.evening : e >= 12 ? o = ne.afternoon : e >= 4 ? o = ne.morning : o = ne.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, a) {
    if (r === "ho") {
      var e = n.getUTCHours() % 12;
      return e === 0 && (e = 12), a.ordinalNumber(e, {
        unit: "hour"
      });
    }
    return G.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, a) {
    return r === "Ho" ? a.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : G.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, a) {
    var e = n.getUTCHours() % 12;
    return r === "Ko" ? a.ordinalNumber(e, {
      unit: "hour"
    }) : x(e, r.length);
  },
  // Hour [1-24]
  k: function(n, r, a) {
    var e = n.getUTCHours();
    return e === 0 && (e = 24), r === "ko" ? a.ordinalNumber(e, {
      unit: "hour"
    }) : x(e, r.length);
  },
  // Minute
  m: function(n, r, a) {
    return r === "mo" ? a.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : G.m(n, r);
  },
  // Second
  s: function(n, r, a) {
    return r === "so" ? a.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : G.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return G.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (r) {
      case "X":
        return je(i);
      case "XXXX":
      case "XX":
        return J(i);
      case "XXXXX":
      case "XXX":
      default:
        return J(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "x":
        return je(i);
      case "xxxx":
      case "xx":
        return J(i);
      case "xxxxx":
      case "xxx":
      default:
        return J(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Qe(i, ":");
      case "OOOO":
      default:
        return "GMT" + J(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Qe(i, ":");
      case "zzzz":
      default:
        return "GMT" + J(i, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, a, e) {
    var o = e._originalDate || n, i = Math.floor(o.getTime() / 1e3);
    return x(i, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, a, e) {
    var o = e._originalDate || n, i = o.getTime();
    return x(i, r.length);
  }
};
function Qe(t, n) {
  var r = t > 0 ? "-" : "+", a = Math.abs(t), e = Math.floor(a / 60), o = a % 60;
  if (o === 0)
    return r + String(e);
  var i = n;
  return r + String(e) + i + x(o, 2);
}
function je(t, n) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + x(Math.abs(t) / 60, 2);
  }
  return J(t, n);
}
function J(t, n) {
  var r = n || "", a = t > 0 ? "-" : "+", e = Math.abs(t), o = x(Math.floor(e / 60), 2), i = x(e % 60, 2);
  return a + o + r + i;
}
var Be = function(n, r) {
  switch (n) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, ot = function(n, r) {
  switch (n) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, Kt = function(n, r) {
  var a = n.match(/(P+)(p+)?/) || [], e = a[1], o = a[2];
  if (!o)
    return Be(n, r);
  var i;
  switch (e) {
    case "P":
      i = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = r.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Be(e, r)).replace("{{time}}", ot(o, r));
}, Ce = {
  p: ot,
  P: Kt
}, Zt = ["D", "DD"], Jt = ["YY", "YYYY"];
function st(t) {
  return Zt.indexOf(t) !== -1;
}
function ut(t) {
  return Jt.indexOf(t) !== -1;
}
function ge(t, n, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var er = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ct = function(n, r, a) {
  var e, o = er[n];
  return typeof o == "string" ? e = o : r === 1 ? e = o.one : e = o.other.replace("{{count}}", r.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + e : e + " ago" : e;
};
function ae(t) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : t.defaultWidth, a = t.formats[r] || t.formats[t.defaultWidth];
    return a;
  };
}
var tr = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, rr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, nr = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ar = {
  date: ae({
    formats: tr,
    defaultWidth: "full"
  }),
  time: ae({
    formats: rr,
    defaultWidth: "full"
  }),
  dateTime: ae({
    formats: nr,
    defaultWidth: "full"
  })
}, ir = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, lt = function(n, r, a, e) {
  return ir[n];
};
function le(t) {
  return function(n, r) {
    var a = r != null && r.context ? String(r.context) : "standalone", e;
    if (a === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, i = r != null && r.width ? String(r.width) : o;
      e = t.formattingValues[i] || t.formattingValues[o];
    } else {
      var s = t.defaultWidth, u = r != null && r.width ? String(r.width) : t.defaultWidth;
      e = t.values[u] || t.values[s];
    }
    var c = t.argumentCallback ? t.argumentCallback(n) : n;
    return e[c];
  };
}
var or = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, sr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ur = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, cr = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, lr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, dr = function(n, r) {
  var a = Number(n), e = a % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, ft = {
  ordinalNumber: dr,
  era: le({
    values: or,
    defaultWidth: "wide"
  }),
  quarter: le({
    values: sr,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: le({
    values: ur,
    defaultWidth: "wide"
  }),
  day: le({
    values: cr,
    defaultWidth: "wide"
  }),
  dayPeriod: le({
    values: lr,
    defaultWidth: "wide",
    formattingValues: fr,
    defaultFormattingWidth: "wide"
  })
};
function fe(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.width, e = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], o = n.match(e);
    if (!o)
      return null;
    var i = o[0], s = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], u = Array.isArray(s) ? mr(s, function(d) {
      return d.test(i);
    }) : vr(s, function(d) {
      return d.test(i);
    }), c;
    c = t.valueCallback ? t.valueCallback(u) : u, c = r.valueCallback ? r.valueCallback(c) : c;
    var v = n.slice(i.length);
    return {
      value: c,
      rest: v
    };
  };
}
function vr(t, n) {
  for (var r in t)
    if (t.hasOwnProperty(r) && n(t[r]))
      return r;
}
function mr(t, n) {
  for (var r = 0; r < t.length; r++)
    if (n(t[r]))
      return r;
}
function hr(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.match(t.matchPattern);
    if (!a) return null;
    var e = a[0], o = n.match(t.parsePattern);
    if (!o) return null;
    var i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    var s = n.slice(e.length);
    return {
      value: i,
      rest: s
    };
  };
}
var pr = /^(\d+)(th|st|nd|rd)?/i, gr = /\d+/i, wr = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, yr = {
  any: [/^b/i, /^(a|c)/i]
}, br = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Tr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xr = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Mr = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Dr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Cr = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Pr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Or = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dt = {
  ordinalNumber: hr({
    matchPattern: pr,
    parsePattern: gr,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: fe({
    matchPatterns: wr,
    defaultMatchWidth: "wide",
    parsePatterns: yr,
    defaultParseWidth: "any"
  }),
  quarter: fe({
    matchPatterns: br,
    defaultMatchWidth: "wide",
    parsePatterns: Tr,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: fe({
    matchPatterns: xr,
    defaultMatchWidth: "wide",
    parsePatterns: Mr,
    defaultParseWidth: "any"
  }),
  day: fe({
    matchPatterns: Dr,
    defaultMatchWidth: "wide",
    parsePatterns: Cr,
    defaultParseWidth: "any"
  }),
  dayPeriod: fe({
    matchPatterns: Pr,
    defaultMatchWidth: "any",
    parsePatterns: Or,
    defaultParseWidth: "any"
  })
}, Ye = {
  code: "en-US",
  formatDistance: ct,
  formatLong: ar,
  formatRelative: lt,
  localize: ft,
  match: dt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, kr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Er = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ur = /^'([^]*?)'?$/, Yr = /''/g, _r = /[a-zA-Z]/;
function _e(t, n, r) {
  var a, e, o, i, s, u, c, v, d, h, m, D, W, N;
  M(2, arguments);
  var R = String(n), U = re(), I = (a = (e = void 0) !== null && e !== void 0 ? e : U.locale) !== null && a !== void 0 ? a : Ye, F = A((o = (i = (s = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && s !== void 0 ? s : U.firstWeekContainsDate) !== null && i !== void 0 ? i : (c = U.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(F >= 1 && F <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var X = A((d = (h = (m = (D = void 0) !== null && D !== void 0 ? D : void 0) !== null && m !== void 0 ? m : U.weekStartsOn) !== null && h !== void 0 ? h : (W = U.locale) === null || W === void 0 || (N = W.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && d !== void 0 ? d : 0);
  if (!(X >= 0 && X <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!I.localize)
    throw new RangeError("locale must contain localize property");
  if (!I.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var z = b(t);
  if (!Wt(z))
    throw new RangeError("Invalid time value");
  var oe = pe(z), se = rt(z, oe), ue = {
    firstWeekContainsDate: F,
    weekStartsOn: X,
    locale: I,
    _originalDate: z
  }, Te = R.match(Er).map(function(_) {
    var H = _[0];
    if (H === "p" || H === "P") {
      var Z = Ce[H];
      return Z(_, I.formatLong);
    }
    return _;
  }).join("").match(kr).map(function(_) {
    if (_ === "''")
      return "'";
    var H = _[0];
    if (H === "'")
      return Nr(_);
    var Z = Vt[H];
    if (Z)
      return ut(_) && ge(_, n, String(t)), st(_) && ge(_, n, String(t)), Z(se, _, I.localize, ue);
    if (H.match(_r))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
    return _;
  }).join("");
  return Te;
}
function Nr(t) {
  var n = t.match(Ur);
  return n ? n[1].replace(Yr, "'") : t;
}
function Ne(t, n) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in n)
    Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  return t;
}
function Wr(t) {
  return Ne({}, t);
}
var Xe = 1440, Ir = 2520, De = 43200, Ar = 86400;
function Hr(t, n, r) {
  var a, e;
  M(2, arguments);
  var o = re(), i = (a = (e = r == null ? void 0 : r.locale) !== null && e !== void 0 ? e : o.locale) !== null && a !== void 0 ? a : Ye;
  if (!i.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var s = he(t, n);
  if (isNaN(s))
    throw new RangeError("Invalid time value");
  var u = Ne(Wr(r), {
    addSuffix: !!(r != null && r.addSuffix),
    comparison: s
  }), c, v;
  s > 0 ? (c = b(n), v = b(t)) : (c = b(t), v = b(n));
  var d = Ft(v, c), h = (pe(v) - pe(c)) / 1e3, m = Math.round((d - h) / 60), D;
  if (m < 2)
    return r != null && r.includeSeconds ? d < 5 ? i.formatDistance("lessThanXSeconds", 5, u) : d < 10 ? i.formatDistance("lessThanXSeconds", 10, u) : d < 20 ? i.formatDistance("lessThanXSeconds", 20, u) : d < 40 ? i.formatDistance("halfAMinute", 0, u) : d < 60 ? i.formatDistance("lessThanXMinutes", 1, u) : i.formatDistance("xMinutes", 1, u) : m === 0 ? i.formatDistance("lessThanXMinutes", 1, u) : i.formatDistance("xMinutes", m, u);
  if (m < 45)
    return i.formatDistance("xMinutes", m, u);
  if (m < 90)
    return i.formatDistance("aboutXHours", 1, u);
  if (m < Xe) {
    var W = Math.round(m / 60);
    return i.formatDistance("aboutXHours", W, u);
  } else {
    if (m < Ir)
      return i.formatDistance("xDays", 1, u);
    if (m < De) {
      var N = Math.round(m / Xe);
      return i.formatDistance("xDays", N, u);
    } else if (m < Ar)
      return D = Math.round(m / De), i.formatDistance("aboutXMonths", D, u);
  }
  if (D = St(v, c), D < 12) {
    var R = Math.round(m / De);
    return i.formatDistance("xMonths", R, u);
  } else {
    var U = D % 12, I = Math.floor(D / 12);
    return U < 3 ? i.formatDistance("aboutXYears", I, u) : U < 9 ? i.formatDistance("overXYears", I, u) : i.formatDistance("almostXYears", I + 1, u);
  }
}
function ze(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var r = 0, a = Array(n); r < n; r++) a[r] = t[r];
  return a;
}
function Lr(t, n) {
  if (t) {
    if (typeof t == "string") return ze(t, n);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ze(t, n) : void 0;
  }
}
function Ge(t, n) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!r) {
    if (Array.isArray(t) || (r = Lr(t)) || n) {
      r && (t = r);
      var a = 0, e = function() {
      };
      return {
        s: e,
        n: function() {
          return a >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[a++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: e
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, i = !0, s = !1;
  return {
    s: function() {
      r = r.call(t);
    },
    n: function() {
      var c = r.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, o = c;
    },
    f: function() {
      try {
        i || r.return == null || r.return();
      } finally {
        if (s) throw o;
      }
    }
  };
}
function f(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Pe(t, n) {
  return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Pe(t, n);
}
function w(t, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), n && Pe(t, n);
}
function we(t) {
  return we = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, we(t);
}
function vt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vt = function() {
    return !!t;
  })();
}
function $r(t, n) {
  if (n && (j(n) == "object" || typeof n == "function")) return n;
  if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return f(t);
}
function y(t) {
  var n = vt();
  return function() {
    var r, a = we(t);
    if (n) {
      var e = we(this).constructor;
      r = Reflect.construct(a, arguments, e);
    } else r = a.apply(this, arguments);
    return $r(this, r);
  };
}
function p(t, n) {
  if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Rr(t, n) {
  if (j(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(t, n || "default");
    if (j(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(t);
}
function mt(t) {
  var n = Rr(t, "string");
  return j(n) == "symbol" ? n : n + "";
}
function qr(t, n) {
  for (var r = 0; r < n.length; r++) {
    var a = n[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, mt(a.key), a);
  }
}
function g(t, n, r) {
  return n && qr(t.prototype, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function l(t, n, r) {
  return (n = mt(n)) in t ? Object.defineProperty(t, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = r, t;
}
var Sr = 10, ht = /* @__PURE__ */ function() {
  function t() {
    p(this, t), l(this, "priority", void 0), l(this, "subPriority", 0);
  }
  return g(t, [{
    key: "validate",
    value: function(r, a) {
      return !0;
    }
  }]), t;
}(), Fr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r(a, e, o, i, s) {
    var u;
    return p(this, r), u = n.call(this), u.value = a, u.validateValue = e, u.setValue = o, u.priority = i, s && (u.subPriority = s), u;
  }
  return g(r, [{
    key: "validate",
    value: function(e, o) {
      return this.validateValue(e, this.value, o);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return this.setValue(e, o, this.value, i);
    }
  }]), r;
}(ht), Qr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", Sr), l(f(a), "subPriority", -1), a;
  }
  return g(r, [{
    key: "set",
    value: function(e, o) {
      if (o.timestampIsSet)
        return e;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), i.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), i;
    }
  }]), r;
}(ht), T = /* @__PURE__ */ function() {
  function t() {
    p(this, t), l(this, "incompatibleTokens", void 0), l(this, "priority", void 0), l(this, "subPriority", void 0);
  }
  return g(t, [{
    key: "run",
    value: function(r, a, e, o) {
      var i = this.parse(r, a, e, o);
      return i ? {
        setter: new Fr(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, a, e) {
      return !0;
    }
  }]), t;
}(), jr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 140), l(f(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(e, {
            width: "abbreviated"
          }) || i.era(e, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(e, {
            width: "wide"
          }) || i.era(e, {
            width: "abbreviated"
          }) || i.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.era = i, e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), k = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, q = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function E(t, n) {
  return t && {
    value: n(t.value),
    rest: t.rest
  };
}
function P(t, n) {
  var r = n.match(t);
  return r ? {
    value: parseInt(r[0], 10),
    rest: n.slice(r[0].length)
  } : null;
}
function S(t, n) {
  var r = n.match(t);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var a = r[1] === "+" ? 1 : -1, e = r[2] ? parseInt(r[2], 10) : 0, o = r[3] ? parseInt(r[3], 10) : 0, i = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: a * (e * Yt + o * Ut + i * _t),
    rest: n.slice(r[0].length)
  };
}
function pt(t) {
  return P(k.anyDigitsSigned, t);
}
function O(t, n) {
  switch (t) {
    case 1:
      return P(k.singleDigit, n);
    case 2:
      return P(k.twoDigits, n);
    case 3:
      return P(k.threeDigits, n);
    case 4:
      return P(k.fourDigits, n);
    default:
      return P(new RegExp("^\\d{1," + t + "}"), n);
  }
}
function ye(t, n) {
  switch (t) {
    case 1:
      return P(k.singleDigitSigned, n);
    case 2:
      return P(k.twoDigitsSigned, n);
    case 3:
      return P(k.threeDigitsSigned, n);
    case 4:
      return P(k.fourDigitsSigned, n);
    default:
      return P(new RegExp("^-?\\d{1," + t + "}"), n);
  }
}
function We(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function gt(t, n) {
  var r = n > 0, a = r ? n : 1 - n, e;
  if (a <= 50)
    e = t || 100;
  else {
    var o = a + 50, i = Math.floor(o / 100) * 100, s = t >= o % 100;
    e = t + i - (s ? 100 : 0);
  }
  return r ? e : 1 - e;
}
function wt(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var Br = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: o === "yy"
        };
      };
      switch (o) {
        case "y":
          return E(O(4, e), s);
        case "yo":
          return E(i.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return E(O(o.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var u = gt(i.year, s);
        return e.setUTCFullYear(u, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var c = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return e.setUTCFullYear(c, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Xr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: o === "YY"
        };
      };
      switch (o) {
        case "Y":
          return E(O(4, e), s);
        case "Yo":
          return E(i.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return E(O(o.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      var u = Ue(e, s);
      if (i.isTwoDigitYear) {
        var c = gt(i.year, u);
        return e.setUTCFullYear(c, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
      }
      var v = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return e.setUTCFullYear(v, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
    }
  }]), r;
}(T), zr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o) {
      return ye(o === "R" ? 4 : o.length, e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(i, 0, 4), s.setUTCHours(0, 0, 0, 0), ie(s);
    }
  }]), r;
}(T), Gr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 130), l(f(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o) {
      return ye(o === "u" ? 4 : o.length, e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Vr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 120), l(f(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "Q":
        case "QQ":
          return O(o.length, e);
        case "Qo":
          return i.ordinalNumber(e, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth((i - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Kr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 120), l(f(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "q":
        case "qq":
          return O(o.length, e);
        case "qo":
          return i.ordinalNumber(e, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth((i - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Zr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), l(f(a), "priority", 110), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c - 1;
      };
      switch (o) {
        case "M":
          return E(P(k.month, e), s);
        case "MM":
          return E(O(2, e), s);
        case "Mo":
          return E(i.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "MMM":
          return i.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(e, {
            width: "wide",
            context: "formatting"
          }) || i.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(i, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), Jr = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 110), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c - 1;
      };
      switch (o) {
        case "L":
          return E(P(k.month, e), s);
        case "LL":
          return E(O(2, e), s);
        case "Lo":
          return E(i.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "LLL":
          return i.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(e, {
            width: "wide",
            context: "standalone"
          }) || i.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(i, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function en(t, n, r) {
  M(2, arguments);
  var a = b(t), e = A(n), o = it(a, r) - e;
  return a.setUTCDate(a.getUTCDate() - o * 7), a;
}
var tn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 100), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "w":
          return P(k.week, e);
        case "wo":
          return i.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return te(en(e, i, s), s);
    }
  }]), r;
}(T);
function rn(t, n) {
  M(2, arguments);
  var r = b(t), a = A(n), e = at(r) - a;
  return r.setUTCDate(r.getUTCDate() - e * 7), r;
}
var nn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 100), l(f(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "I":
          return P(k.week, e);
        case "Io":
          return i.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return ie(rn(e, i));
    }
  }]), r;
}(T), an = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], on = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], sn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "subPriority", 1), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "d":
          return P(k.date, e);
        case "do":
          return i.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      var i = e.getUTCFullYear(), s = wt(i), u = e.getUTCMonth();
      return s ? o >= 1 && o <= on[u] : o >= 1 && o <= an[u];
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCDate(i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), un = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "subpriority", 1), l(f(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "D":
        case "DD":
          return P(k.dayOfYear, e);
        case "Do":
          return i.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      var i = e.getUTCFullYear(), s = wt(i);
      return s ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMonth(0, i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function Ie(t, n, r) {
  var a, e, o, i, s, u, c, v;
  M(2, arguments);
  var d = re(), h = A((a = (e = (o = (i = r == null ? void 0 : r.weekStartsOn) !== null && i !== void 0 ? i : r == null || (s = r.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && e !== void 0 ? e : (c = d.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = b(t), D = A(n), W = m.getUTCDay(), N = D % 7, R = (N + 7) % 7, U = (R < h ? 7 : 0) + D - W;
  return m.setUTCDate(m.getUTCDate() + U), m;
}
var cn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ie(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), ln = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i, s) {
      var u = function(v) {
        var d = Math.floor((v - 1) / 7) * 7;
        return (v + s.weekStartsOn + 6) % 7 + d;
      };
      switch (o) {
        case "e":
        case "ee":
          return E(O(o.length, e), u);
        case "eo":
          return E(i.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "eee":
          return i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ie(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), fn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i, s) {
      var u = function(v) {
        var d = Math.floor((v - 1) / 7) * 7;
        return (v + s.weekStartsOn + 6) % 7 + d;
      };
      switch (o) {
        case "c":
        case "cc":
          return E(O(o.length, e), u);
        case "co":
          return E(i.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "ccc":
          return i.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(e, {
            width: "wide",
            context: "standalone"
          }) || i.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(e, {
            width: "short",
            context: "standalone"
          }) || i.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(e, o, i, s) {
      return e = Ie(e, i, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T);
function dn(t, n) {
  M(2, arguments);
  var r = A(n);
  r % 7 === 0 && (r = r - 7);
  var a = 1, e = b(t), o = e.getUTCDay(), i = r % 7, s = (i + 7) % 7, u = (s < a ? 7 : 0) + r - o;
  return e.setUTCDate(e.getUTCDate() + u), e;
}
var vn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 90), l(f(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (o) {
        case "i":
        case "ii":
          return O(o.length, e);
        case "io":
          return i.ordinalNumber(e, {
            unit: "day"
          });
        case "iii":
          return E(i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return E(i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return E(i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return E(i.day(e, {
            width: "wide",
            context: "formatting"
          }) || i.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(e, {
            width: "short",
            context: "formatting"
          }) || i.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 7;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e = dn(e, i), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(T), mn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(We(i), 0, 0, 0), e;
    }
  }]), r;
}(T), hn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(We(i), 0, 0, 0), e;
    }
  }]), r;
}(T), pn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 80), l(f(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(We(i), 0, 0, 0), e;
    }
  }]), r;
}(T), gn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "h":
          return P(k.hour12h, e);
        case "ho":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 12;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCHours() >= 12;
      return s && i < 12 ? e.setUTCHours(i + 12, 0, 0, 0) : !s && i === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), wn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "H":
          return P(k.hour23h, e);
        case "Ho":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 23;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), yn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "K":
          return P(k.hour11h, e);
        case "Ko":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = e.getUTCHours() >= 12;
      return s && i < 12 ? e.setUTCHours(i + 12, 0, 0, 0) : e.setUTCHours(i, 0, 0, 0), e;
    }
  }]), r;
}(T), bn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 70), l(f(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "k":
          return P(k.hour24h, e);
        case "ko":
          return i.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 1 && o <= 24;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      var s = i <= 24 ? i % 24 : i;
      return e.setUTCHours(s, 0, 0, 0), e;
    }
  }]), r;
}(T), Tn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 60), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "m":
          return P(k.minute, e);
        case "mo":
          return i.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMinutes(i, 0, 0), e;
    }
  }]), r;
}(T), xn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 50), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o, i) {
      switch (o) {
        case "s":
          return P(k.second, e);
        case "so":
          return i.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return O(o.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCSeconds(i, 0), e;
    }
  }]), r;
}(T), Mn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 30), l(f(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o) {
      var i = function(u) {
        return Math.floor(u * Math.pow(10, -o.length + 3));
      };
      return E(O(o.length, e), i);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return e.setUTCMilliseconds(i), e;
    }
  }]), r;
}(T), Dn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 10), l(f(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o) {
      switch (o) {
        case "X":
          return S(q.basicOptionalMinutes, e);
        case "XX":
          return S(q.basic, e);
        case "XXXX":
          return S(q.basicOptionalSeconds, e);
        case "XXXXX":
          return S(q.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return S(q.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), r;
}(T), Cn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 10), l(f(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e, o) {
      switch (o) {
        case "x":
          return S(q.basicOptionalMinutes, e);
        case "xx":
          return S(q.basic, e);
        case "xxxx":
          return S(q.basicOptionalSeconds, e);
        case "xxxxx":
          return S(q.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return S(q.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return o.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), r;
}(T), Pn = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 40), l(f(a), "incompatibleTokens", "*"), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e) {
      return pt(e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(T), On = /* @__PURE__ */ function(t) {
  w(r, t);
  var n = y(r);
  function r() {
    var a;
    p(this, r);
    for (var e = arguments.length, o = new Array(e), i = 0; i < e; i++)
      o[i] = arguments[i];
    return a = n.call.apply(n, [this].concat(o)), l(f(a), "priority", 20), l(f(a), "incompatibleTokens", "*"), a;
  }
  return g(r, [{
    key: "parse",
    value: function(e) {
      return pt(e);
    }
  }, {
    key: "set",
    value: function(e, o, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(T), kn = {
  G: new jr(),
  y: new Br(),
  Y: new Xr(),
  R: new zr(),
  u: new Gr(),
  Q: new Vr(),
  q: new Kr(),
  M: new Zr(),
  L: new Jr(),
  w: new tn(),
  I: new nn(),
  d: new sn(),
  D: new un(),
  E: new cn(),
  e: new ln(),
  c: new fn(),
  i: new vn(),
  a: new mn(),
  b: new hn(),
  B: new pn(),
  h: new gn(),
  H: new wn(),
  K: new yn(),
  k: new bn(),
  m: new Tn(),
  s: new xn(),
  S: new Mn(),
  X: new Dn(),
  x: new Cn(),
  t: new Pn(),
  T: new On()
}, En = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Un = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Yn = /^'([^]*?)'?$/, _n = /''/g, Nn = /\S/, Wn = /[a-zA-Z]/;
function In(t, n, r, a) {
  var e, o, i, s, u, c, v, d, h, m, D, W, N, R;
  M(3, arguments);
  var U = String(t), I = String(n), F = re(), X = (e = (o = void 0) !== null && o !== void 0 ? o : F.locale) !== null && e !== void 0 ? e : Ye;
  if (!X.match)
    throw new RangeError("locale must contain match property");
  var z = A((i = (s = (u = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && u !== void 0 ? u : F.firstWeekContainsDate) !== null && s !== void 0 ? s : (v = F.locale) === null || v === void 0 || (d = v.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(z >= 1 && z <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var oe = A((h = (m = (D = (W = void 0) !== null && W !== void 0 ? W : void 0) !== null && D !== void 0 ? D : F.weekStartsOn) !== null && m !== void 0 ? m : (N = F.locale) === null || N === void 0 || (R = N.options) === null || R === void 0 ? void 0 : R.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(oe >= 0 && oe <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (I === "")
    return U === "" ? b(r) : /* @__PURE__ */ new Date(NaN);
  var se = {
    firstWeekContainsDate: z,
    weekStartsOn: oe,
    locale: X
  }, ue = [new Qr()], Te = I.match(Un).map(function(Y) {
    var C = Y[0];
    if (C in Ce) {
      var $ = Ce[C];
      return $(Y, X.formatLong);
    }
    return Y;
  }).join("").match(En), _ = [], H = Ge(Te), Z;
  try {
    var Tt = function() {
      var C = Z.value;
      !(a != null && a.useAdditionalWeekYearTokens) && ut(C) && ge(C, I, t), !(a != null && a.useAdditionalDayOfYearTokens) && st(C) && ge(C, I, t);
      var $ = C[0], me = kn[$];
      if (me) {
        var Re = me.incompatibleTokens;
        if (Array.isArray(Re)) {
          var qe = _.find(function(Se) {
            return Re.includes(Se.token) || Se.token === $;
          });
          if (qe)
            throw new RangeError("The format string mustn't contain `".concat(qe.fullToken, "` and `").concat(C, "` at the same time"));
        } else if (me.incompatibleTokens === "*" && _.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(C, "` and any other token at the same time"));
        _.push({
          token: $,
          fullToken: C
        });
        var Me = me.run(U, C, X.match, se);
        if (!Me)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        ue.push(Me.setter), U = Me.rest;
      } else {
        if ($.match(Wn))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + $ + "`");
        if (C === "''" ? C = "'" : $ === "'" && (C = An(C)), U.indexOf(C) === 0)
          U = U.slice(C.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (H.s(); !(Z = H.n()).done; ) {
      var Ae = Tt();
      if (j(Ae) === "object") return Ae.v;
    }
  } catch (Y) {
    H.e(Y);
  } finally {
    H.f();
  }
  if (U.length > 0 && Nn.test(U))
    return /* @__PURE__ */ new Date(NaN);
  var xt = ue.map(function(Y) {
    return Y.priority;
  }).sort(function(Y, C) {
    return C - Y;
  }).filter(function(Y, C, $) {
    return $.indexOf(Y) === C;
  }).map(function(Y) {
    return ue.filter(function(C) {
      return C.priority === Y;
    }).sort(function(C, $) {
      return $.subPriority - C.subPriority;
    });
  }).map(function(Y) {
    return Y[0];
  }), xe = b(r);
  if (isNaN(xe.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var ce = rt(xe, pe(xe)), He = {}, de = Ge(xt), Le;
  try {
    for (de.s(); !(Le = de.n()).done; ) {
      var $e = Le.value;
      if (!$e.validate(ce, se))
        return /* @__PURE__ */ new Date(NaN);
      var ve = $e.set(ce, He, se);
      Array.isArray(ve) ? (ce = ve[0], Ne(He, ve[1])) : ce = ve;
    }
  } catch (Y) {
    de.e(Y);
  } finally {
    de.f();
  }
  return ce;
}
function An(t) {
  return t.match(Yn)[1].replace(_n, "'");
}
function Sa(t, n = /([8-9]|1\d|2[0-9]|3[01]) days|month|months|year|years/, r = "MM/dd/yyyy") {
  const a = Hr(t.getTime(), /* @__PURE__ */ new Date(), {
    addSuffix: !0
  }).replace(/about/, "").replace(/less than a minute ago/, "Just now").replace(/1 minute ago/, "Just now").replace(/1 day ago/, "Yesterday").trim();
  return a.match(n) ? _e(t, r) : a;
}
function Fa(t = "MM/dd/yyyy") {
  return _e(/* @__PURE__ */ new Date(), t);
}
var Hn = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Ln = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $n = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rn = {
  date: ae({
    formats: Hn,
    defaultWidth: "full"
  }),
  time: ae({
    formats: Ln,
    defaultWidth: "full"
  }),
  dateTime: ae({
    formats: $n,
    defaultWidth: "full"
  })
}, qn = {
  code: "en-GB",
  formatDistance: ct,
  formatLong: Rn,
  formatRelative: lt,
  localize: ft,
  match: dt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Sn = {
  lastWeek: "'Last' eeee",
  yesterday: "'Yesterday'",
  today: "'Today'",
  tomorrow: "'Tomorrow'",
  nextWeek: "'Next' eeee",
  other: "MM/dd/yyyy"
}, Qa = {
  ...qn,
  formatRelative: (t) => Sn[t]
}, ja = (t) => {
  console.log("Error handled by mutation", { error: t });
}, Ba = (t, n, r) => t === 1 ? n : r, Xa = (t) => t === !0 ? "Yes" : t === !1 ? "No" : "", za = (t) => {
  var n, r;
  return !!((n = t == null ? void 0 : t.draft) != null && n[0]) && !((r = t == null ? void 0 : t.message) != null && r.some(
    (a) => {
      var e;
      return ((e = a.status) == null ? void 0 : e.toLowerCase()) !== "draft";
    }
  ));
};
function Ga(t) {
  if (t === void 0 || t === "")
    return { keyword: void 0, isValid: !0 };
  const n = t.trim();
  return {
    keyword: n,
    isValid: n.length >= 3
  };
}
const Fn = (t) => ({ label: t, value: t }), Va = (t) => t == null ? void 0 : t.split(",").filter((n) => !!n).map(Fn), Ka = (t) => !t || !Array.isArray(t) ? [] : t == null ? void 0 : t.map((n) => n == null ? void 0 : n.value);
let Qn = { data: "" }, jn = (t) => typeof window == "object" ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : t || Qn, Bn = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Xn = /\/\*[^]*?\*\/|  +/g, Ve = /\n+/g, V = (t, n) => {
  let r = "", a = "", e = "";
  for (let o in t) {
    let i = t[o];
    o[0] == "@" ? o[1] == "i" ? r = o + " " + i + ";" : a += o[1] == "f" ? V(i, o) : o + "{" + V(i, o[1] == "k" ? "" : n) + "}" : typeof i == "object" ? a += V(i, n ? n.replace(/([^,])+/g, (s) => o.replace(/(^:.*)|([^,])+/g, (u) => /&/.test(u) ? u.replace(/&/g, s) : s ? s + " " + u : u)) : o) : i != null && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), e += V.p ? V.p(o, i) : o + ":" + i + ";");
  }
  return r + (n && e ? n + "{" + e + "}" : e) + a;
}, Q = {}, yt = (t) => {
  if (typeof t == "object") {
    let n = "";
    for (let r in t) n += r + yt(t[r]);
    return n;
  }
  return t;
}, zn = (t, n, r, a, e) => {
  let o = yt(t), i = Q[o] || (Q[o] = ((u) => {
    let c = 0, v = 11;
    for (; c < u.length; ) v = 101 * v + u.charCodeAt(c++) >>> 0;
    return "go" + v;
  })(o));
  if (!Q[i]) {
    let u = o !== t ? t : ((c) => {
      let v, d, h = [{}];
      for (; v = Bn.exec(c.replace(Xn, "")); ) v[4] ? h.shift() : v[3] ? (d = v[3].replace(Ve, " ").trim(), h.unshift(h[0][d] = h[0][d] || {})) : h[0][v[1]] = v[2].replace(Ve, " ").trim();
      return h[0];
    })(t);
    Q[i] = V(e ? { ["@keyframes " + i]: u } : u, r ? "" : "." + i);
  }
  let s = r && Q.g ? Q.g : null;
  return r && (Q.g = Q[i]), ((u, c, v, d) => {
    d ? c.data = c.data.replace(d, u) : c.data.indexOf(u) === -1 && (c.data = v ? u + c.data : c.data + u);
  })(Q[i], n, a, s), i;
}, Gn = (t, n, r) => t.reduce((a, e, o) => {
  let i = n[o];
  if (i && i.call) {
    let s = i(r), u = s && s.props && s.props.className || /^go/.test(s) && s;
    i = u ? "." + u : s && typeof s == "object" ? s.props ? "" : V(s, "") : s === !1 ? "" : s;
  }
  return a + e + (i ?? "");
}, "");
function be(t) {
  let n = this || {}, r = t.call ? t(n.p) : t;
  return zn(r.unshift ? r.raw ? Gn(r, [].slice.call(arguments, 1), n.p) : r.reduce((a, e) => Object.assign(a, e && e.call ? e(n.p) : e), {}) : r, jn(n.target), n.g, n.o, n.k);
}
let bt, Oe, ke;
be.bind({ g: 1 });
let B = be.bind({ k: 1 });
function Vn(t, n, r, a) {
  V.p = n, bt = t, Oe = r, ke = a;
}
function K(t, n) {
  let r = this || {};
  return function() {
    let a = arguments;
    function e(o, i) {
      let s = Object.assign({}, o), u = s.className || e.className;
      r.p = Object.assign({ theme: Oe && Oe() }, s), r.o = / *go\d+/.test(u), s.className = be.apply(r, a) + (u ? " " + u : "");
      let c = t;
      return t[0] && (c = s.as || t, delete s.as), ke && c[0] && ke(s), bt(c, s);
    }
    return e;
  };
}
var Kn = (t) => typeof t == "function", Zn = (t, n) => Kn(t) ? t(n) : t, Jn = /* @__PURE__ */ (() => {
  let t;
  return () => {
    if (t === void 0 && typeof window < "u") {
      let n = matchMedia("(prefers-reduced-motion: reduce)");
      t = !n || n.matches;
    }
    return t;
  };
})(), ea = B`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, ta = B`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ra = B`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, na = K("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(t) => t.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ea} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${ta} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(t) => t.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${ra} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, aa = B`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, ia = K("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(t) => t.secondary || "#e0e0e0"};
  border-right-color: ${(t) => t.primary || "#616161"};
  animation: ${aa} 1s linear infinite;
`, oa = B`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, sa = B`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, ua = K("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(t) => t.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${oa} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${sa} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(t) => t.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, ca = K("div")`
  position: absolute;
`, la = K("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, fa = B`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, da = K("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${fa} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, va = ({ toast: t }) => {
  let { icon: n, type: r, iconTheme: a } = t;
  return n !== void 0 ? typeof n == "string" ? L.createElement(da, null, n) : n : r === "blank" ? null : L.createElement(la, null, L.createElement(ia, { ...a }), r !== "loading" && L.createElement(ca, null, r === "error" ? L.createElement(na, { ...a }) : L.createElement(ua, { ...a })));
}, ma = (t) => `
0% {transform: translate3d(0,${t * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, ha = (t) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${t * -150}%,-1px) scale(.6); opacity:0;}
`, pa = "0%{opacity:0;} 100%{opacity:1;}", ga = "0%{opacity:1;} 100%{opacity:0;}", wa = K("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, ya = K("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, ba = (t, n) => {
  let r = t.includes("top") ? 1 : -1, [a, e] = Jn() ? [pa, ga] : [ma(r), ha(r)];
  return { animation: n ? `${B(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${B(e)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
L.memo(({ toast: t, position: n, style: r, children: a }) => {
  let e = t.height ? ba(t.position || n || "top-center", t.visible) : { opacity: 0 }, o = L.createElement(va, { toast: t }), i = L.createElement(ya, { ...t.ariaProps }, Zn(t.message, t));
  return L.createElement(wa, { className: t.className, style: { ...e, ...r, ...t.style } }, typeof a == "function" ? a({ icon: o, message: i }) : L.createElement(L.Fragment, null, o, i));
});
Vn(L.createElement);
be`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
function Za(t) {
  const n = t.type ? ` (${t.type})` : "";
  return `Could not upload ${t.name} because it is not a supported file type${n}.`;
}
const Ja = ({
  dateString: t,
  inputFormat: n = "yyyy-MM-dd",
  outputFormat: r = "MM/dd/yyyy",
  defaultPlaceholder: a = ""
}) => {
  if (!t)
    return a;
  const e = In(t, n, /* @__PURE__ */ new Date());
  return _e(e, r);
};
function ei(t, ...n) {
  return (r) => n.reduce(
    (a, e) => a.replace(/:[^/]+/, `${r[e]}`),
    t
  );
}
const ti = (t) => {
  var r;
  return ((r = (Array.from(t)[0] === "/" ? t : `/${t}`).split("/")) == null ? void 0 : r[1]) || "";
};
function ri(t) {
  const n = et();
  return ee(() => {
    n.current = t;
  }), n.current;
}
const Ke = (t) => {
  t.preventDefault();
  const n = "Leave Site? Changes you made may not be saved.";
  return t.returnValue = n, n;
}, ni = (t) => {
  ee(() => (t && window.addEventListener("beforeunload", Ke), () => {
    window.removeEventListener("beforeunload", Ke);
  }), [t]);
}, ai = (t) => {
  const [n, r] = tt();
  return ee(() => {
    t != null && t.current && r(t == null ? void 0 : t.current.getBoundingClientRect());
  }, [r, t]), n;
}, ii = (t, n, r = !0) => {
  ee(() => {
    if (!n || !r)
      return;
    const a = setTimeout(t, n);
    return () => {
      clearTimeout(a);
    };
  }, [t, n, r]);
}, Ze = (t, n, r) => ({
  value: t,
  timestamp: (/* @__PURE__ */ new Date()).getTime(),
  duration: n,
  elapsedDuration: r
}), Je = ({
  value: t,
  duration: n,
  elapsedDuration: r,
  timestamp: a
}) => {
  const e = typeof n == "function" ? n(t) : n;
  if (r) {
    const o = (/* @__PURE__ */ new Date()).getTime() - a;
    return Math.max(e - o, 0);
  }
  return e;
}, oi = (t, {
  duration: n = 500,
  skipLapsed: r = !0,
  elapsedDuration: a = !0
} = {}) => {
  const e = et(), [o, i] = tt([
    Ze(t, n, a)
  ]), s = o[0], u = s == null ? void 0 : s.value, c = Mt(() => {
    i((v) => {
      if (v.length === 1)
        return v;
      const d = v.slice(1);
      if (!d[1])
        return d;
      if (r)
        return d.slice(-1);
      const m = d[0], D = Je({
        ...m,
        elapsedDuration: m.elapsedDuration && d.length === 1
      });
      return D > 0 ? (e.current = setTimeout(c, D), d) : (d.shift(), d);
    });
  }, [r]);
  return ee(() => {
    i((v) => {
      const d = [...v], h = Ze(
        t,
        n,
        a
      );
      if (d[d.length - 1].value === t)
        return v;
      if (d.push(h), v.length > 1)
        return d;
      const m = Je(s);
      return m > 0 ? (e.current = setTimeout(c, m), d) : [h];
    });
  }, [t]), ee(() => () => {
    clearTimeout(e.current);
  }, []), u;
};
function si(t) {
  ee(t, []);
}
const ui = (t, n = []) => {
  const r = Object.fromEntries(t);
  n.forEach((a) => {
    delete r[a];
  });
  for (const [a, e] of Object.entries(r))
    if (e === "true" && (r[a] = !0), e === "false" && (r[a] = !1), typeof e == "string" && !["true", "false"].includes(e)) {
      const o = Number(e);
      isNaN(o) || (r[a] = o);
    }
  return r;
}, ci = (t, n) => {
  var a, e;
  return (((e = (a = t == null ? void 0 : t.response) == null ? void 0 : a.data) == null ? void 0 : e.errors) || []).some((o) => o.type === n);
}, li = (t) => t.map((n) => n.message).join(", ");
export {
  Ct as DEFAULT_ERROR_MESSAGE,
  Pt as capitalize,
  _a as capitalizeAndSingularize,
  ci as containsErrorOfType,
  ui as convertQueryStringToObject,
  ka as copyCurrentUrlToClipboard,
  Ze as createStateQueueItem,
  Ea as createStorageUtil,
  Ya as defaultErrorParser,
  Dt as defaultPrecisionResolver,
  ja as errorHandledByMutation,
  Na as escapeHtml,
  La as formatAiContent,
  Ra as formatPercent,
  Ja as formatStringDate,
  Za as formatUnsupportedFileMessage,
  Je as getDeferredValueTimeout,
  ti as getFirstUrlElementFromLink,
  Xa as getIsTextingAllowedLabel,
  Da as getScrollValue,
  Ka as getValuesFromRichOptions,
  za as isDraftOnlyThread,
  Qa as locale,
  Fa as makeFormattedToday,
  Fn as makeRichOption,
  Va as makeRichOptionsFromCSV,
  ei as makeRouteParamsFn,
  Wa as newLinesHtml,
  Ga as normalizeMessageSearchKeyword,
  Ot as parseAmount,
  Aa as parseBytesToKBString,
  qa as parseCentsToDollars,
  Ha as parseFileName,
  li as parseValidationErrors,
  Ba as pluralLabel,
  Oa as preventBubbling,
  Ua as readableBytes,
  Pa as scrollToElement,
  Ca as setScrollValue,
  Sa as timeAgo,
  Ia as titleCase,
  ni as useBeforeUnload,
  ai as useClientBoundingRect,
  si as useEffectOnce,
  ri as usePrevious,
  ii as useTimeout,
  oi as useTimeoutValue,
  Ma as validatePassword,
  $a as wholePercent
};
